import React from "react";
import { motion } from "framer-motion";
import Marquee from "react-fast-marquee";

const EASE = [0.22, 1, 0.36, 1];

const PEOPLE = [
  {
    name: "Abhinav Bhardwaj",
    roleLine1: "Director,",
    roleLine2: "Business & Strategy",
    initials: "AB",
    photo: "/people/abhinav.webp",
    bio:
      "20 years in BTL, media, and brand launches for Adidas, Hyundai, and Toyota. Ex-Encompass, Reliance Broadcast, Wizcraft — brings big ideas and flawless execution to marquee projects.",
  },
  {
    name: "Ashish Sharma",
    roleLine1: "Director,",
    roleLine2: "Head of Operations",
    initials: "AS",
    photo: "/people/ashish.webp",
    bio:
      "Nearly 20 years across brand activations, large-format events, and government summits. Ex-Wizcraft and Encompass, known for flawless nationwide delivery and strong vendor networks.",
  },
  {
    name: "Siddharth Pal",
    roleLine1: "Director,",
    roleLine2: "Content & Strategy",
    initials: "SP",
    photo: "/people/siddharth.webp",
    bio:
      "15+ years in brand building, from leading Under Armour India marketing to shaping campaigns for Adidas and Nando’s. Today, drives content for global names like Monster, Nike, and Under Armour.",
  },
  {
    name: "Ishani Sapra",
    roleLine1: "Director,",
    roleLine2: "Creative & Design",
    initials: "IS",
    photo: "/people/ishani.webp",
    bio:
      "Delhi-based creative with a Master’s from NIFT and BFA in Applied Arts. Specializes in design, brand styling, and storytelling, with work spanning Adidas, Hyundai, Toyota, and Star Sports.",
  },
  {
    name: "Sharun Trehan",
    roleLine1: "Director,",
    roleLine2: "Live Events",
    initials: "ST",
    photo: "/people/sharun.webp",
    bio:
      "Architect-turned-event specialist with 10+ years in live experiences, ex-Paytm Insider. Blends space design, pop culture, and experiential marketing to craft standout events.",
  },
];

const TAGS = ["Storymakers", "Vibe-etters", "Impact Architects", "Production Ninjas"];

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="shell py-20 md:py-28"
    >
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.8, ease: EASE }}
        className="border-b border-[color:var(--collab-hairline)] pb-6 text-center"
      >
        <h2 className="font-display font-light text-4xl md:text-6xl leading-[1.05] tracking-[-0.02em] balance mx-auto">
          Our People
        </h2>
      </motion.div>

      {/* 5-up team grid */}
      <div className="mt-12 md:mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8 md:gap-6">
        {PEOPLE.map((p, i) => (
          <motion.figure
            key={p.name}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.7, ease: EASE, delay: (i % 5) * 0.06 }}
            className="flex flex-col"
            data-testid={`person-${i}`}
          >
            {/* Photo — copper-ringed circular portrait (initials as fallback) */}
            <div className="w-[132px] md:w-[140px] aspect-square rounded-full border-[3px] border-[#C67C4E] p-[6px] mb-6">
              {p.photo ? (
                <img
                  src={p.photo}
                  alt={p.name}
                  data-testid={`person-photo-${i}`}
                  className="w-full h-full rounded-full object-cover object-top select-none"
                  loading="lazy"
                  draggable="false"
                />
              ) : (
                <div className="w-full h-full rounded-full bg-[color:var(--collab-cream-2)] flex items-center justify-center">
                  <span className="font-display text-2xl md:text-3xl text-[color:var(--collab-forest)] tracking-tight">
                    {p.initials}
                  </span>
                </div>
              )}
            </div>

            <h3 className="font-sans font-semibold text-[color:var(--collab-ink)] text-lg md:text-xl leading-tight">
              {p.name}
            </h3>
            <div className="mt-1 font-sans font-semibold text-[color:var(--collab-ink)] text-sm md:text-base leading-tight">
              <div>{p.roleLine1}</div>
              <div>{p.roleLine2}</div>
            </div>

            <p className="mt-6 text-[color:var(--collab-ink)] text-sm leading-relaxed max-w-[240px]">
              {p.bio}
            </p>
          </motion.figure>
        ))}
      </div>

      {/* Bottom tag marquee — italic serif on cream, matching site marquee style */}
      <div className="mt-16 md:mt-20 py-2 md:py-3">
        <Marquee speed={55} gradient={false} pauseOnHover>
          {Array.from({ length: 3 }).flatMap((_, loop) =>
            TAGS.map((tag) => (
              <span
                key={`${loop}-${tag}`}
                className="font-display italic font-light text-[color:var(--collab-forest)] text-2xl md:text-4xl lg:text-5xl leading-[1.2] whitespace-nowrap flex items-center px-6 md:px-10 pb-1"
              >
                {tag}
                <span
                  aria-hidden
                  className="inline-block w-2 h-2 rounded-full bg-[color:var(--collab-lime)] mx-6 md:mx-10 align-middle"
                />
              </span>
            ))
          )}
        </Marquee>
      </div>
    </section>
  );
}
